<template>
    <Calendar
        ref="calendar"
        class="reservation-date-picker"
        v-model="dateValue"
        :manualInput="false"
        :dateFormat="dateFormat"
        :minDate="currentMinDate"
        :maxDate="currentMaxDate"
        :disabledDates="props.disabledDates"
        :inputId="props.inputId"
        showIcon
        @show="onShowCalendarOverlay"
        @hide="onHideCalendarOverlay"
        :showButtonBar="false"
        iconDisplay="input"
        @click="onClickCalendar"
    >
        <template #inputicon>
            <i class="calendar-dropdown-icon far fa-chevron-down" style="pointer-events: none"></i>
        </template>
        <template #date="slotProps">
            <strong v-if="isDisabledDate(slotProps.date)" style="text-decoration: line-through">{{
                slotProps.date.day
            }}</strong>
            <template v-else>{{ slotProps.date.day }}</template>
        </template>
    </Calendar>
</template>

<script setup lang="ts">
    import { DateTime } from "@/data/util/DateTime";
    import { computed, ref, watch } from "vue";

    import Calendar from "primevue/calendar";

    // define props
    const props = defineProps<{
        modelValue: Date | null;
        minDate?: Date;
        maxDate?: Date;
        disabledDates?: Date[];
        inputId?: string;
    }>();

    // define emits
    const emit = defineEmits(["update:modelValue"]);

    const calendar = ref();
    const isCalendarOverlayOpen = ref(false);

    function onClickCalendar() {
        if (calendar.value.overlayVisible === true && isCalendarOverlayOpen.value === true) {
            calendar.value.overlayVisible = false;
        }
    }

    function onShowCalendarOverlay() {
        console.log("onShow");
        setTimeout(() => {
            isCalendarOverlayOpen.value = true;
        }, 300);
    }

    function onHideCalendarOverlay() {
        isCalendarOverlayOpen.value = false;
    }

    // define state
    const dateValue = ref(props.modelValue);
    const dateFormat = computed(() => {
        return "D '-' dd.mm.yy";
    });
    const currentMinDate = computed(() => {
        return props.minDate ?? DateTime.getToday();
    });
    const currentMaxDate = computed(() => {
        return props.maxDate;
    });
    const disabledDateDict = computed(() => {
        const result = {};
        props.disabledDates?.forEach((date) => {
            result[DateTime.toDateString(date)] = true;
        });
        return result;
    });

    // define functions
    function isDisabledDate(date: { day: number; month: number; year: number; today: boolean; selectable: boolean }) {
        const dateString = DateTime.toDateString(new Date(date.year, date.month, date.day));
        const isDisabledDate = disabledDateDict.value[dateString];
        return isDisabledDate == true;
    }

    // event handlers
    watch(dateValue, (newValue) => {
        emit("update:modelValue", newValue);
    });

    // update watchers
    watch(
        () => props.modelValue,
        (newValue) => {
            dateValue.value = newValue;
        }
    );
</script>

<style lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";

    .reservation-date-picker {
        input {
            text-align: left;
            color: colors.$fontColor;
            min-width: 100px;
            width: 160px;
            border-radius: 4px;
            padding: 0.5em;
            font-size: 14px !important;
            padding-right: 2em;
            box-shadow: none !important;
            cursor: pointer;
        }

        .calendar-dropdown-icon {
            right: 1rem !important;
            cursor: pointer;

            font-family: "Font Awesome 5 Pro";
        }
    }
</style>
